import {
  CreateMerchantUserBySalesperson,
  CreateOnboardingUser,
  SignUpPayload,
  VerifyDocumentNumberResponse,
  VerifyOtpPayload,
  PreSignUpResponse,
  NaturalPersonData,
} from '@types'
import { Service } from '@tino-frontend/adapters'
import { REACT_APP_ENV, REACT_APP_SUPPLIER_ID_DEFAULT } from 'constants/envs'

export class SignUpService {
  private path = '/sign-up'

  constructor(
    private readonly http: Service,
    private readonly merchantHttp: Service,
    private readonly authHttp: Service
  ) {}

  createOnboardingUser(payload: CreateOnboardingUser) {
    return this.merchantHttp.post(`/v1${this.path}`, payload)
  }

  createMerchantUserBySalesperson(payload: CreateMerchantUserBySalesperson) {
    return this.http.post(`/salesperson/users`, payload)
  }

  createMerchantUserBySupplier(payload: CreateMerchantUserBySalesperson) {
    return this.http.post(
      `/suppliers/${payload.supplier_company_id}/merchants`,
      payload
    )
  }

  verifyDocumentNumber(
    email: string,
    documentNumber: string
  ): Promise<VerifyDocumentNumberResponse> {
    return this.http.get(
      `/users/${email}/natural-person/${documentNumber}/is-owner`
    )
  }

  getNaturalPersonData(): Promise<NaturalPersonData> {
    return this.http.get('/natural-person')
  }

  preSignUp(payload: SignUpPayload): Promise<PreSignUpResponse> {
    const origin =
      REACT_APP_ENV === 'stg' ? 'https://stg.app.tino.com.br' : window.origin

    let supplierId =
      payload.supplier_id ||
      sessionStorage.getItem('supplier_id') ||
      REACT_APP_SUPPLIER_ID_DEFAULT
    if (supplierId === 'undefined') supplierId = REACT_APP_SUPPLIER_ID_DEFAULT

    return this.http.post('/lead', {
      name: payload.name,
      email: payload.email,
      mobile_phone: payload.phone,
      natural_person_document_number: payload.natural_person_document_number,
      natural_person_document_type: 'CPF',
      company_document_number: payload.company_document_number,
      company_document_type: 'CNPJ',
      metadata: {
        url: `${origin}?supplier_id=${supplierId}`,
        search_utm: `supplier_id=${supplierId}`,
        terms: payload.terms,
        ...(payload.referral_supplier && {
          referral_supplier: payload.referral_supplier,
        }),
      },
      origin,
    })
  }

  sendOtp(phone: string) {
    return this.authHttp.post(`/v1${this.path}/whatsapp/otp`, {
      phone: `+${phone}`,
    })
  }

  verifyOtp(payload: VerifyOtpPayload) {
    return this.authHttp.post(`/v1${this.path}/whatsapp/otp/verify`, {
      ...payload,
      phone: `+${payload.phone}`,
    })
  }
}
